import React, { useState, useRef, useEffect } from "react";
import "./dateRangePicker.scss";
import { Box, Grid } from "@mui/material";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import calender_icon from "../../globals/assets/Icon metro-calendar (2).svg";
import "react-datepicker/dist/react-datepicker.css";
import {
  TrainingListingPageFilter,
  FeedbackListingPageFilter,
} from "../../redux/filter/FilterRedux";

const TP_DateRange = (props) => {
  const dispatch = useDispatch();
  const datepicker_ref = useRef();
  let from = moment();
  let end = moment();
  const [dateRange, setDateRange] = useState([from?._d, end?._d]);
  const [startDate, endDate] = dateRange;
  const [clear, setclear] = useState(false);
  const openDatePicker = () => {
    datepicker_ref.current.onInputClick();
  };
  const clearDateField = () => {
    datepicker_ref.current.clear();
    setclear(true);
  };
  useEffect(() => {
    if (startDate && endDate) {
      dispatch(TrainingListingPageFilter({ startDate, endDate }));
      dispatch(FeedbackListingPageFilter({ startDate, endDate }));
    } else if (!startDate && !endDate) {
      dispatch(TrainingListingPageFilter({ startDate: "", endDate: "" }));
      dispatch(FeedbackListingPageFilter());
    }
  }, [startDate, endDate, clear]);

  return (
    <>
      <Grid container justifyContent="space-around">
        <div className="alignSelf_centre">Select Date</div>
        <div>
          <div className="date_Picker">
            <DatePicker
              ref={datepicker_ref}
              selectsRange={true}
              dateFormat="dd/MM/yyyy"
              startDate={startDate}
              endDate={endDate}
              onChange={(update) => {
                setDateRange(update);
              }}
              placeholderText="DD/MM/YYYY-DD/MM/YYYY"
              monthsShown={2}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
            <img src={calender_icon} onClick={openDatePicker} />
          </div>
        </div>
        <div className="cleartext_color" onClick={clearDateField}>
          Clear
        </div>
      </Grid>
    </>
  );
};

export default TP_DateRange;
